
const mutations = {
  //-Update the store with the new criterias for approved companies
  SET_APPROVED_CRITERIAS(state, criterias) {
    state.approved_companies_criterias = criterias
  },
  //-Update the store with the new criterias for non approved companies
  SET_UNAPPROVED_CRITERIAS(state, criterias) {
    state.unapproved_companies_criterias = criterias
  },  
  //-Update the store with the boolean true or false for approvment 
  SET_ISAPPROVED_COMPANIES(state, isApproved) {
    state.is_approved_companies = isApproved
  }
  
}
export default mutations
